import Axios from 'axios'
import store from '../redux/store'
import { getNotiCount } from '../redux/actions/notificationAction'

export const base_url = 'https://hockeybackend.samsports.io'
// export const base_url = 'http://localhost:9000'

export const publicAPI = Axios.create({ baseURL: base_url })

export const privateAPI = Axios.create({ baseURL: base_url })

export const attachToken = async () => {
  const jwt = localStorage.getItem('token')
  privateAPI.defaults.headers.common.Authorization = `Bearer ${jwt}`
}

privateAPI.interceptors.response.use(
  async (response) => {
    store?.dispatch(getNotiCount())
    return response
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const isLocked = () => {
  const SETTING = store?.getState()?.user
  return SETTING?.setting?.date < SETTING?.currentDate ? true : false
  // true is when we have selected current week
}

export const version = '2.0.4'

export const activeRosterCount = 20
export const practiceRosterCount = 27
export const legalPlayers = 23
export const nonActivePlayers = 3
export const proctectedSquadCount = 4
export const reservedPlayer = 15

export const leagueSalaryCap = 83500000

export const leagueStart = '2023-10-10'

// const landingUrl = "http://localhost:3000/"
const landingUrl = 'https://samsports.io'

export const landingSignup = () => window.open(landingUrl, '_self')
